import { activateIcon } from './24/activate';
import { arrowDownIcon } from './24/arrow_down';
import { calendarIcon } from './24/calendar';
import { checkbookIcon } from './24/checkbook';
import { contentCopyIcon } from './24/content_copy';
import { debtIcon } from './24/debt';
import { downloadIcon } from './24/download';
import { emptyStateIcon } from './24/empty-state';
import { fileImageIcon } from './24/file-image';
import { infoCircleIcon } from './24/info-circle';
import { loadingIcon } from './24/loading';
import { noFilterIcon } from './24/no-filter';
import { overpaymentIcon } from './24/overpayment';
import { paymentIcon } from './24/payment';
import { pdfIcon } from './24/pdf';
import { savingsIcon } from './24/savings';
import { userIdIcon } from './24/user-id';

export const icons = [
  checkbookIcon,
  debtIcon,
  downloadIcon,
  noFilterIcon,
  overpaymentIcon,
  paymentIcon,
  savingsIcon,
  calendarIcon,
  activateIcon,
  pdfIcon,
  userIdIcon,
  arrowDownIcon,
  loadingIcon,
  contentCopyIcon,
  emptyStateIcon,
  fileImageIcon,
  infoCircleIcon,
];
